const DEFAULT_WORK_HOUR_PER_DAY = 8

export function formatLeaveDuration(value, workHour = DEFAULT_WORK_HOUR_PER_DAY) {
  if (value == null || value === '' || isNaN(value)) return '-'

  const hoursPerDay = workHour > 0 ? workHour : DEFAULT_WORK_HOUR_PER_DAY
  const sign = value < 0 ? '-' : ''
  const absValue = Math.abs(value)

  let days = Math.floor(absValue)
  const remainderDays = absValue - days
  let hours = Math.floor(remainderDays * hoursPerDay)

  if (hours >= hoursPerDay) {
    days += 1
    hours = 0
  }

  if (days > 0 && hours > 0) return `${sign}${days} วัน ${hours} ชั่วโมง`
  if (days > 0) return `${sign}${days} วัน`
  if (hours > 0) return `${sign}${hours} ชั่วโมง`
  return '0 วัน'
}
